import React, { createContext, useContext } from 'react'

export const FiltersContext = createContext({
  resetPage: undefined,
  dateRange: [],
  setDateRange: undefined,
  adminFeedback: '',
  setAdminFeedback: undefined,
  visitorFeedback: '',
  setVisitorFeedback: undefined,
  botResponse: '',
  setBotResponse: undefined
})

export const FiltersContextProvider = ({ value, children }) => {
  return <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
}

export const useFilterContext = () => useContext(FiltersContext)
